module.exports = __webpack_public_path__ + "static/img/hyimg.c6e9836.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hyimg.jpg
// module id = C/bQ
// module chunks = 1